<template>
  <Listbox v-model="model" as="div" class="relative z-50">
    <ListboxButton
      class="input-default relative z-50 flex cursor-pointer items-center text-primary"
    >
      <div class="flex items-center space-x-2">
        <span class="text-sm 2xl:text-base">
          <span v-if="model">
            {{ model.name }}
          </span>
          <span v-else> {{ $t('cart.choose_city') }}</span>
        </span>
      </div>
      <inline-svg
        alt="edit-icon"
        class="ml-2 transform"
        height="6"
        loading="lazy"
        :src="useAsset(`icons/base/edit.svg`)"
        width="14"
      />
    </ListboxButton>

    <transition
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <ListboxOptions
        class="shadow-select relative z-40 mt-2 max-h-36 w-full max-w-[212px] space-y-2 overflow-auto border bg-white px-4 py-3 scrollbar-thin scrollbar-track-gray scrollbar-thumb-primary focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 sm:max-h-96 sm:space-y-4"
      >
        <ListboxOption
          v-for="city in cities"
          :key="city"
          :value="city"
          as="template"
        >
          <li
            class="transition-ease-in-out relative flex cursor-pointer select-none items-center text-sm hover:underline hover:brightness-50 md:text-base"
          >
            <div class="flex items-center space-x-2 text-primary">
              <span>
                {{ city.name }}
              </span>
            </div>
          </li>
        </ListboxOption>
      </ListboxOptions>
    </transition>
  </Listbox>
</template>

<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue'
import { useCartStore } from '~/stores/cart'
import InlineSvg from 'vue-inline-svg'

const props = defineProps({
  modelValue: {
    type: [Object, null],
    required: true,
  },
})
const emit = defineEmits(['update:modelValue'])

const cartStore = useCartStore()

const cities = computed(() => {
  return cartStore.cities
})

if (cities.value.length === 0) {
  await cartStore.fetchCities()
}

const model = computed({
  get() {
    return props.modelValue
  },
  set(newValue) {
    emit('update:modelValue', newValue)
  },
})
</script>
